import axios from "axios"
import { isDevAuthBypassEnabled } from "../helper/auth"
import {
  publishCreditRefusal,
  publishCreditResponse,
} from "../helper/creditStateEvents"

const get_axios_api = () => {
  return axios.create({
    timeout: 30000,
    withCredentials: true
  })
}

export const authenticated_api = get_axios_api()
export const unauthenticated_api = get_axios_api()

export const configureApiBaseUrl = (apiBaseUrl) => {
  authenticated_api.defaults.baseURL = apiBaseUrl;
  unauthenticated_api.defaults.baseURL = apiBaseUrl;
};

// Single-flight refresh: concurrent 401s share one in-flight refresh call
// instead of each issuing their own. The shared promise redirects to log in
// exactly once on failure and is reset after it settles so a later 401 can
// trigger a fresh refresh.
let refresh_in_flight = null;

const refresh_session = () => {
  if (!refresh_in_flight) {
    refresh_in_flight = unauthenticated_api
      .post("/token/refresh/")
      .catch((refreshError) => {
        if (!isDevAuthBypassEnabled()) {
          window.location.assign("/");
        }
        throw refreshError;
      })
      .finally(() => {
        refresh_in_flight = null;
      });
  }
  return refresh_in_flight;
};

// This will intercept any 401 returns from the api and attempt a single silent
// refresh before redirecting back to log in if refresh fails.
authenticated_api.interceptors.response.use(
  (response) => {
    publishCreditResponse(response);
    return response;
  },
  async (error) => {
    const status = error?.response?.status;
    const original = error.config;

    publishCreditRefusal(error?.response);

    if (status !== 401 || original._retried) {
      return Promise.reject(error);
    }

    original._retried = true;

    try {
      await refresh_session();
      return authenticated_api(original);
    } catch {
      return Promise.reject(error);
    }
  }
);
